import { render } from "./UserAccountSettings.vue?vue&type=template&id=a1e4860a&scoped=true&lang=html"
import script from "./UserAccountSettings.vue?vue&type=script&lang=js"
export * from "./UserAccountSettings.vue?vue&type=script&lang=js"

import "./UserAccountSettings.vue?vue&type=style&index=0&id=a1e4860a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e4860a"]])

export default __exports__